"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
var _typographyStylex = require("web/shared/typography.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * The vocabulary every jobs view speaks.
 *
 * What lives here is what more than one view uses: the pills a state is shown
 * in, and the roles text plays. A view's own chrome, its log block and its
 * detail grid live beside the component that draws them.
 *
 * Identifiers, numbers, states, and times are set in monospace so columns line
 * up and a value is scannable at a glance, while prose (a job's description, a
 * log message) keeps the product's own face.
 *
 * Deliberately the jobs console's alone. A schedule of discrete runs is its
 * own mechanism, and a stylesheet shared with an unrelated console would be a
 * thing neither owns and both are afraid to change. What consoles share is
 * the product's own design tokens, which is where a resemblance belongs.
 */
const styles = exports.styles = {
  pill: {
    display: "x1rg5ohu",
    fontFamily: "xm3uy08",
    fontSize: "x9bimuu",
    fontWeight: "x1s688f",
    letterSpacing: "x16q24ku",
    paddingTop: "xjcdsdd",
    paddingBottom: "x1u6aujs",
    paddingLeft: "x15u6esi",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x1arb9wb",
    borderRadius: "x12oqio5",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "xkjg22i",
    whiteSpace: "xuxw1ft",
    $$css: true
  },
  pillMuted: {
    fontWeight: "xo1l8bm",
    color: "xcdm7ny",
    backgroundColor: "xjbqb8w",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  statusGood: {
    color: "x1qti9gz",
    $$css: true
  },
  statusBad: {
    color: "xwiuzjs",
    $$css: true
  },
  statusRunning: {
    color: "x19p3n1p",
    $$css: true
  },
  statusNeutral: {
    color: "xcdm7ny",
    $$css: true
  },
  stackedCell: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x1i0ffca",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  mono: {
    fontFamily: "xm3uy08",
    fontVariantNumeric: "xss6m8b",
    fontSize: "x9bimuu",
    color: "x10kmngs",
    whiteSpace: "xuxw1ft",
    $$css: true
  },
  prose: {
    fontFamily: "x1wl88yq",
    fontSize: "x9bimuu",
    color: "xcdm7ny",
    $$css: true
  },
  errorText: {
    fontFamily: "xm3uy08",
    fontSize: "x9bimuu",
    color: "xwiuzjs",
    $$css: true
  },
  subHeading: {
    fontFamily: "xm3uy08",
    fontSize: "x1ksoetq",
    fontWeight: "x1s688f",
    marginTop: "xdj266r",
    marginBottom: "x1gr9t9r",
    color: "x10kmngs",
    $$css: true
  }
};